import Paper from '@aura/components/paper'
import { withStyles } from '@aura/components/styles'
import Typography from '@aura/components/typography'
import Icon from '@aura/components/icon'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles from './styles'


const messageIcons = {
    'info': <InfoOutlineIcon />,
    'logout': <CheckCircleOutlineIcon />,
    'passwordChanged': <CheckCircleOutlineIcon />,
}

const MessageContainer = ({
    children,
    classes,
    message,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()
    const messageIcon = messageIcons[message] || messageIcons.info

    return (<Paper spacing={2} className={classes.registrationContainer}>
        <Icon color="success" fontSize="large" className={classes.icon} gutterBottom>{messageIcon}</Icon>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.verbiage}>{verbiage}</Typography>
        <Paper className={classes.childrenContainer}>{children}</Paper>
    </Paper>)
}

MessageContainer.propTypes = {
    children: PropTypes.object,
    classes: PropTypes.object,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(MessageContainer, styles)
